<script setup lang="ts">
/**
 * UiKitSwitch — переключатель HeroUI UI-kit. Figma: 1818-361.
 * Цвета только из токенов (классы hui-*).
 */
import { BG, RING, type HuiColor, type HuiSize } from './palette'

const props = withDefaults(
  defineProps<{
    color?: HuiColor
    size?: HuiSize
    disabled?: boolean
  }>(),
  { color: 'primary', size: 'md', disabled: false },
)

const model = defineModel<boolean>({ default: false })

defineOptions({ name: 'UiKitSwitch' })

function toggle() {
  if (props.disabled) return
  model.value = !model.value
}

const TRACK: Record<HuiSize, string> = {
  sm: 'w-8 h-5 p-0.5',
  md: 'w-11 h-6 p-0.5',
  lg: 'w-[52px] h-7 p-0.5',
}
const THUMB: Record<HuiSize, string> = { sm: 'w-4 h-4', md: 'w-5 h-5', lg: 'w-6 h-6' }
const TRANSLATE: Record<HuiSize, string> = { sm: 'translate-x-3', md: 'translate-x-5', lg: 'translate-x-6' }
const TEXT_SIZE: Record<HuiSize, string> = { sm: 'text-sm', md: 'text-base', lg: 'text-lg' }

const trackClass = computed(() => [
  'relative inline-flex shrink-0 items-center rounded-full transition-colors duration-200 outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-hui-background',
  TRACK[props.size],
  RING[props.color],
  model.value ? BG[props.color] : 'bg-hui-default-300',
])
</script>

<template>
  <label
    class="relative inline-flex items-center gap-2 select-none"
    :class="disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'"
  >
    <input type="checkbox" class="sr-only" role="switch" :checked="model" :disabled="disabled" @change="toggle" />
    <span :class="trackClass" :tabindex="disabled ? -1 : 0" @keydown.space.prevent="toggle">
      <span
        class="pointer-events-none inline-block rounded-full bg-white shadow-md transition-transform duration-200"
        :class="[THUMB[size], model ? TRANSLATE[size] : 'translate-x-0']"
      />
    </span>
    <span v-if="$slots.default" :class="[TEXT_SIZE[size], 'text-hui-foreground leading-tight']">
      <slot />
    </span>
  </label>
</template>
